import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  lastReloadTime: '',
};

const slice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    onReloadNotification(state) {
      state.lastReloadTime = new Date();
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { onReloadNotification } = slice.actions;
